import React from 'react';
import { json } from '@remix-run/node';
import { useLoaderData } from '@remix-run/react';
import type { MetaFunction } from '@remix-run/node';
import { HeroSection } from '~/components/home/HeroSection';
import { FeatureGrid } from '~/components/home/FeatureGrid';
import { MusicPlayer } from '~/components/home/MusicPlayer';
import { LatestNews } from '~/components/home/LatestNews';
import { metaHome } from '~/lib/meta-templates';
import { getAllPosts } from '~/lib/blog.static';
import {
  createOrganizationSchema,
  createVideoGameSchema,
  createWebSiteSchema,
  SchemaMarkup,
} from '~/lib/schema-markup';

export const meta: MetaFunction = metaHome;

export async function loader() {
  // Get all blog posts
  const allPosts = await getAllPosts();

  // Sort by date (newest first)
  const sortedPosts = allPosts.sort((a, b) => {
    const dateA = new Date(a.date || '1970-01-01');
    const dateB = new Date(b.date || '1970-01-01');
    return dateB.getTime() - dateA.getTime();
  });

  // Get the latest 3 posts
  const latestPosts = sortedPosts.slice(0, 3);

  return json({ posts: latestPosts });
}

export default function Index() {
  const { posts } = useLoaderData<typeof loader>();
  // Generate JSON-LD structured data for SEO
  const schemaMarkup = [
    createOrganizationSchema(),
    createVideoGameSchema(),
    createWebSiteSchema(),
  ];

  return (
    <>
      {/* JSON-LD Schema Markup for Rich Snippets */}
      <SchemaMarkup schema={schemaMarkup} />

      <div className="bg-black">
        {/* Hero Section with Video Background */}
        <HeroSection />

        {/* Feature Showcase Grid */}
        <FeatureGrid />

        {/* Music Player */}
        <MusicPlayer />

        {/* Latest News & Updates */}
        <LatestNews posts={posts} />
      </div>
    </>
  );
}
